import "./AboutContentStyles.css";
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";  // Import Framer Motion

// Import images
import React1 from "../assets/react1.jpg";
import React2 from "../assets/react2.png";
import React3 from "../assets/react3.png";
import React4 from "../assets/react4.png";
import React5 from "../assets/react5.png";

const AboutContent = () => {
  return (
    <div className="about">
      {/* About Text Section with Animation */}
      <div className="left">
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          About Me
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          A passionate and results-driven Full-Stack Developer specializing
          in cutting-edge technologies such as JavaScript(Typescriopt), HTML, CSS, React.js, Next.js, Angular.js,
          Node.js and MongoDB. With a strong foundation in both front-end and
          back-end development, I excel at creating user-friendly, visually
          appealing, and high-performing websites and applications tailored to
          meet client needs.
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
          My approach is not just about writing code—it's about understanding
          your vision and translating it into a seamless digital experience. I
          thrive on solving complex challenges, optimizing performance, and
          ensuring every project is delivered with precision, creativity, and
          innovation.
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.9 }}
        >
          Whether you’re looking to build a sleek portfolio, an e-commerce
          platform, or a custom web solution, I am committed to delivering
          top-notch results. I also stay updated with the latest industry
          trends, ensuring your project benefits from modern design and
          development practices.
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.1 }}
        >
          Let’s collaborate to create something extraordinary that sets your
          business apart. Together, we can transform your ideas into impactful
          solutions that leave a lasting impression on your audience.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.3 }}
        >
          <Link to="/contact">
            <button className="btn">Contact</button>
          </Link>
        </motion.div>
      </div>

      {/* Logos Section with Animation */}
      <div className="right">
        {/* Wrap each image in a motion div to animate them */}
        <motion.div
          className="img-stack"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.5 }}
        >
          <img src={React1} className="img" alt="React Logo 1" />
        </motion.div>

        <motion.div
          className="img-stack"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.7 }}
        >
          <img src={React2} className="img" alt="React Logo 2" />
        </motion.div>

        <motion.div
          className="img-stack"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.9 }}
        >
          <img src={React3} className="img" alt="React Logo 3" />
        </motion.div>

        <motion.div
          className="img-stack"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 2.1 }}
        >
          <img src={React4} className="img" alt="React Logo 4" />
        </motion.div>

        <motion.div
          className="img-stack"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 2.3 }}
        >
          <img src={React5} className="img" alt="React Logo 5" />
        </motion.div>
      </div>
    </div>
  );
};

export default AboutContent;
